import React from 'react'
import { compact, find } from 'lodash'
import {
  useNavigate,
  Link
} from "react-router-dom"

import AppFrame from '../AppFrame'
import { generateUrl } from '../helpers/clinic'

export default ({globalData}) => {
  const navigate = useNavigate()

  const path = window.location.pathname.split('/')[1] // purge leading slash
  const clinic = find(globalData.clinics, (c) => {
    return c.url === path
  })
  // check if services page, then redirect to services root

  let pathElements = window.location.pathname.split('/')
  pathElements = compact(pathElements)

  if (pathElements.indexOf('services') !== -1 && pathElements.indexOf('services') !== pathElements.length) {
    pathElements.pop()
    window.location.href = `/${pathElements.join('/')}`
  }

  const homeLink = generateUrl(clinic, '')

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto text-center min-h-[500px] py-[200px]">
        <div className="text-3xl text-sky-500 font-bold">page not found!</div>
        <div className="text-normal hover:underline"><Link to={homeLink}>click here to return home</Link></div>
      </div>
    </AppFrame>
  )
}